import {ChangeEvent, useEffect, useState} from 'react';
import {
  APP_CONFIGURATION_KEYS,
  CODE,
  COMPONENT_TYPE,
  ITEM_DATA_SOURCE,
  RESPONSE_MESSAGE
} from '../../../../../utils/Constant';
import {getTreeDataBenhAn} from '../../../../services/BenhAnServices';
import {useBenhAnContext} from '../../../../contexts/BenhAnContext';
import {toast} from 'react-toastify';
import {useAppContext} from 'src/app/modules/appContext/AppContext';
import {usePhanHeKhamBenhContext} from "../../../../contexts/PhanHeTiepDonContext";
import {LOAI_BENH_AN} from "src/app/modules/phan-he-kham-benh/constants/BenhAn";
import {IconMenu} from 'src/app/modules/component/IconSvg';
import InputSearch from 'src/app/modules/component/InputSearch';
import SelectTree from 'src/app/modules/component/SelectTree';
import {localStorageItem} from "../../../../../utils/LocalStorage";
import {KEY_LOCALSTORAGE} from "../../../../../auth/core/_consts";
import {parseJSON} from "../../../../../utils/FormatUtils";
import axios from "axios";
import {
  fillTemplate,
  replacePathVariablesTemplate,
  replaceTemplateString,
  replaceTemplateValues,
} from "../../../../../utils/AppFunction";

export const BenhAnTree = () => {
  const {benhNhanInfo} = usePhanHeKhamBenhContext();
  const {setPhieuBenhAn} = useBenhAnContext();
  const {setIsLoading} = useAppContext();

  const [nodeIdSelected, setNodeIdSelected] = useState<string>(LOAI_BENH_AN.THONG_TIN_BENH_AN.HO_SO_BENH_AN);
  const [treeData, setTreeData] = useState<any>({
    code: 'all',
    name: 'Bệnh nhân',
    icon: <IconMenu/>,
    filter: [],
  });
  const [codeCollapses, setCodeCollapses] = useState<string[]>([]);

  useEffect(() => {
    handleGetTreeData();
  }, []);

  const onNodeSelected = (data: any) => {
    if (!data) return;
    setPhieuBenhAn({
      ...data,
      attributes: {
        ...data.attributes,
        isMultiple: data.attributes?.isMultiple === '1',
      },
    });
  };

  const onSearch = (e: ChangeEvent<HTMLInputElement>) => {
  };

  const handleGetTreeData = async () => {
    try {
      setIsLoading(true);
      const {data} = await getTreeDataBenhAn({
        orderId: benhNhanInfo?.thongTinKhamBenh?.orderId || null
      });
      if (data?.code === CODE.SUCCESS && data?.data?.length) {
        setTreeData({
          code: 'all',
          name: 'Bệnh nhân',
          icon: <IconMenu/>,
          filter: data?.data,
        });
        setPhieuBenhAn(data?.data[0]?.filter[0]);
        setNodeIdSelected(data?.data[0]?.filter[0]?.code);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const updateTreeData = (code: string, nodeData: any, callbackFn?: () => void) => {
    const nodeIndex = getNodeIndex(code);
    treeData.filter[nodeIndex].filter = nodeData;
    setTreeData(treeData);
    callbackFn?.();
  };

  const getNodeIndex = (code: string) => {
    return treeData.filter.findIndex((node: any) => node.code === code);
  };

  const getNodeData = async (node: any, callbackFn?: () => void) => {
    let code = node?.code;
    const attributes = node?.attributes || {};
    const config = parseJSON(attributes?.additionalConfiguration) ?? {};
    const configData = config?.data ?? {};

    const BASE_ENDPOINT = localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION)?.[
      configData?.baseUrl || APP_CONFIGURATION_KEYS.API_URL
    ] || process.env.REACT_APP_API_URL || "";
    try {
      let nodeData: any = [];

      if (attributes.renderType === COMPONENT_TYPE.LIST && attributes.itemDataSource === ITEM_DATA_SOURCE.URL) {
        const {pathVariables, url, method, pattern} = configData;
        const payload = Array.isArray(pathVariables)
          ? fillTemplate(pathVariables, benhNhanInfo?.thongTinKhamBenh)
          : replaceTemplateValues(pathVariables, benhNhanInfo?.thongTinKhamBenh);
        let finalUrl = replacePathVariablesTemplate(url, pathVariables, benhNhanInfo?.thongTinKhamBenh);

        if (typeof method === 'string' && "GET".toLowerCase() === method.toLowerCase()) {
          const {data} = await axios.get(`${BASE_ENDPOINT}${finalUrl}`, payload);
          nodeData = data.data.map((item: any) => {
            return {
              ...item,
              name: replaceTemplateString(pattern, item),
              displayCode: code,
              attributes: {
                ...node?.attributes,
                ...item?.attributes,
                ...config?.item,
                renderType: (config.item?.renderType || config.renderType) ?? (item.filter ? COMPONENT_TYPE.LIST : COMPONENT_TYPE.FORM)
              }
            }
          });
        }
      }
      updateTreeData(code, nodeData, callbackFn);
    } catch (error) {
      console.error(error);
      toast.error(RESPONSE_MESSAGE.ERROR);
      callbackFn?.();
    }
  };

  return (
    <div>
      <div className="spaces px-12 py-5">
        <InputSearch
          placeholder="Tìm kiếm"
          handleChange={onSearch}
          className="spaces h-32 pr-4 radius-3"
        />
      </div>
      <div>
        <SelectTree
          className="spaces w-100 py-2 ps-4 flex-grow-1 border border-top-0 border-bottom-0 overflow-auto"
          idSelected={nodeIdSelected}
          handleChangeSelectId={setNodeIdSelected}
          getSelectedItem={onNodeSelected}
          selectTree={treeData}
          codeCollapses={codeCollapses}
          handleChangeCollapsesCode={setCodeCollapses}
          truncateTextNode={false}
          expandAllNode={false}
          onNodeExpand={(node, expandCallbackFn) => {
            getNodeData(node, expandCallbackFn);
          }}
          defaultExpandCodes={[LOAI_BENH_AN.THONG_TIN_BENH_AN.DEFAULT]}
        />
      </div>
    </div>
  );
};
